import { CustomColumn } from '../../../types/customColumn';
import { ProductStockDTO } from '../../../types/inventory/ProductStockTypes';
import { formatCurrency } from '../../../utils/formatCurrency';

/**
 * Columnas para mostrar la gestión de stock de productos
 */
export const inventoryStockColumns: CustomColumn<ProductStockDTO>[] = [
  /**
   * 📦 Producto
   */
  {
    Header: 'Producto',
    accessor: 'productName',
    customCell: ({ row }) => (
      <div className="min-w-[240px] max-w-[320px]">
        <div className="font-medium text-black dark:text-white">
          {row.original.productName || '—'}
        </div>
      </div>
    ),
  },

  /**
   * 🏢 Sucursal
   */
  {
    Header: 'Sucursal',
    accessor: 'branchName',
    customCell: ({ row }) => (
      <div className="min-w-[180px]">
        <span className="text-gray-700 dark:text-gray-300 text-sm">
          {row.original.branchName || '—'}
        </span>
      </div>
    ),
  },

  /**
   * 📊 Existencias
   */
  {
    Header: 'Existencias',
    accessor: 'stockQuantity',
    customCell: ({ row }) => (
      <div className="min-w-[140px]">
        <span className="font-medium text-black dark:text-white">
          {formatCurrency(row.original.stockQuantity || 0)}
        </span>
      </div>
    ),
  },

  /**
   * 💰 Costo promedio
   */
  {
    Header: 'Costo Promedio',
    accessor: 'averageCost',
    showStatus: true,
    customCell: ({ row }) => (
      <div className="min-w-[160px]">
        <span className="font-bold text-primary">
          ${formatCurrency(row.original.averageCost || 0)}
        </span>
      </div>
    ),
  },

  /**
   * ⚠️ Stock mínimo
   */
  {
    Header: 'Stock Mínimo',
    accessor: 'minStock',
    customCell: ({ row }) => (
      <div className="min-w-[140px]">
        <span className="text-sm font-medium text-warning">
          {formatCurrency(row.original.minStock || 0)}
        </span>
      </div>
    ),
  },

  /**
   * 🔁 Punto de Reorden
   */
  {
    Header: 'Punto de Reorden',
    accessor: 'reorderPoint',
    customCell: ({ row }) => (
      <div className="min-w-[160px]">
        <span className="text-gray-600 dark:text-gray-400 text-sm font-medium">
          {formatCurrency(row.original.reorderPoint || 0)}
        </span>
      </div>
    ),
  },
];
